import React from "react";

const Pagination = ({
    page,
    totalPages,
    totalItems,
    limit,
    onPageChange,
}) => {
    const start = (page - 1) * limit + 1;
    const end = Math.min(page * limit, totalItems);

    return (
        <>
        {totalPages>1 && <>
        <div className="flex justify-between items-center mt-4 mb-4">
            {/* Showing Text */}
            <p className="text-sm text-gray-600">
                Showing {start} to {end} of {totalItems} results
            </p>

            {/* Pagination Buttons */}
            <div className="flex space-x-2">
                <button
                    onClick={() => onPageChange(page - 1)}
                    disabled={page === 1}
                    className="px-3 py-1 border rounded-lg text-sm text-gray-700 bg-white 
                    hover:bg-gray-100 disabled:opacity-50"
                >
                    Previous
                </button>

                <span className="px-3 py-1 border rounded-lg text-sm text-primary-brown bg-gray-100">
                    {page}
                </span>

                <button
                    onClick={() => onPageChange(page + 1)}
                    disabled={page === totalPages}
                    className="px-3 py-1 border rounded-lg text-sm text-gray-700 bg-white 
                    hover:bg-gray-100 disabled:opacity-50"
                >
                    Next
                </button>
            </div>
        </div>
        </>
}</>
    );
};

export default Pagination;
